export default {
  apiUrl: null,
  lang: null,
  tag: null,
  page: 1,
  init(moduleEl) {
    this.apiUrl = moduleEl.dataset.apiurl;
    this.lang = moduleEl.dataset.lang;

    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    this.tag = searchParams.get('filter[tag]') ?? null;

    window.smr_eventbus.on('load_more_references', () => {
      this.page += 1;

      this.getData(true);
    });

    window.smr_eventbus.on('load_references', (tag) => {
      this.tag = tag;
      this.page = 1;

      this.getData();
    });
  },
  getData(append = false) {
    let url = this.apiUrl;

    if (this.tag) {
      url += `?filter[tag]=${this.tag}`;
    }

    if (this.lang !== 'de') {
      url += (this.tag ? '&' : '?') + `lang=${this.lang}`;
    }

    if (this.page > 1) {
      url += (this.tag || this.lang !== 'de' ? '&' : '?') + `page=${this.page}`;
    }

    // get data from api
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (!append) {
          window.smr_eventbus.emit('data loaded: replace_references', data);
          return;
        }

        window.smr_eventbus.emit('data loaded: append_references', data);
      });
  },
};
